/**
 * Extract address components from Google geocode response
 */
function parseAddressComponents(addressComponents) {
  const result = {
    city: '',
    state: '',
    country: '',
    country_code: '',
    zip_code: '',
  };

  if (!addressComponents) return result;

  for (const component of addressComponents) {
    const types = component.types || [];

    // City: locality or sublocality
    if (types.includes('locality')) {
      result.city = component.long_name;
    } else if (types.includes('sublocality_level_1') && !result.city) {
      result.city = component.long_name;
    } else if (types.includes('administrative_area_level_2') && !result.city) {
      // Fallback to county if no city found
      result.city = component.long_name;
    }

    // State
    if (types.includes('administrative_area_level_1')) {
      result.state = component.short_name; // Use short_name for state (e.g., "OH" instead of "Ohio")
    }

    // Country
    if (types.includes('country')) {
      result.country = component.long_name;
      result.country_code = component.short_name;
    }

    // Zip code
    if (types.includes('postal_code')) {
      result.zip_code = component.long_name;
    }
  }

  return result;
}

export async function getGeoCode(placeId) {
  if (!window.google?.maps) {
    throw new Error('Google Maps not loaded!');
  }
  const { Geocoder } = await window.google.maps.importLibrary('geocoding');
  const geocoder = new Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode(
      { placeId },
      (responses, status) => {
        if (status === 'OK') {
          const result = responses[0];
          const lat = result.geometry.location.lat();
          const lng = result.geometry.location.lng();
          const addressData = parseAddressComponents(result.address_components);

          resolve({
            lat,
            lng,
            ...addressData,
          });
          return;
        }
        reject(new Error(status));
      },
    );
  });
}

export { parseAddressComponents };

export function normalizeLatLng(latLng) {
  return {
    lat: typeof latLng.lat === 'function' ? latLng.lat() : latLng.lat,
    lng: typeof latLng.lng === 'function' ? latLng.lng() : latLng.lng,
  };
}
